import Modal from 'components/Modal';
import { ModalHeader, ModalBody, ModalTitle, ModalContent } from 'ui/modal';
import { Buttons, Button, List } from 'ui';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { getDistributionLists } from 'api/places';
import { useSelector } from 'react-redux';
import { useQuery } from 'react-query';
import DistributionListCard from 'components/DistributionListCard';
import { find, isEqual, pick } from 'lodash';

const BuildingDistributionListsPickerModal = ({
  onRequestClose,
  onAddEntities,
  initialSelectedDistributionsList = [],
}) => {
  const selectedPlaceId = useSelector(state => state.ui.selectedPlaceId);
  const { t } = useTranslation('newConversation');
  const [selectedDistributionLists, setSelectedDistributionLists] = useState(
    initialSelectedDistributionsList,
  );

  const { data: distributionsListData } = useQuery(
    ['distributionsList', selectedPlaceId],
    () => getDistributionLists(selectedPlaceId),
  );
  const distributionLists = (distributionsListData?.data || [])
    .filter(({ kind }) => kind === 'building')
    .map((distributionList, index) => ({
      ...distributionList,
      id: `${selectedPlaceId}-${index}`,
    }));

  const handleSubmit = () => {
    onAddEntities(
      selectedDistributionLists.map(distributionList => ({
        entity: distributionList,
        type: 'DISTRIBUTION_LIST',
      })),
    );
    onRequestClose();
  };

  return (
    <Modal isOpen onRequestClose={onRequestClose}>
      <ModalContent>
        <ModalHeader>
          <ModalTitle small>{t('buildings')}</ModalTitle>
        </ModalHeader>

        <ModalBody>
          <List gutterSize={1}>
            {distributionLists.map(distributionList => (
              <li key={distributionList.id}>
                <DistributionListCard
                  displayName={distributionList.displayName}
                  count={distributionList.userCount}
                  onAdd={() =>
                    setSelectedDistributionLists([
                      ...selectedDistributionLists,
                      distributionList,
                    ])
                  }
                  isActive={Boolean(
                    find(selectedDistributionLists, dl =>
                      isEqual(
                        pick(dl, ['userIds', 'displayName', 'updatedAt']),
                        pick(distributionList, [
                          'userIds',
                          'displayName',
                          'updatedAt',
                        ]),
                      ),
                    ),
                  )}
                />
              </li>
            ))}
          </List>

          <Buttons right marged>
            <Button onClick={onRequestClose}>{t('misc:cancel')}</Button>
            <Button isPrimary onClick={handleSubmit}>
              {t('misc:add')}
            </Button>
          </Buttons>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default BuildingDistributionListsPickerModal;
